module.exports = __webpack_public_path__ + "img/mag-1.87fe726f.jpg";